exports.data = JSON.parse(`
{
  "results": [
      {
          "id": 1,
          "name": "NMI"
      },
      {
          "id": 2,
          "name": "iPaytotal"
      },
      {
          "id": 3,
          "name": "Unicrypt"
      }
  ],
  "count": 3
}
`)
